"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.popularBuildings = exports.buildings = exports.popularDistricts = exports.districts = void 0;
var MegaMenuLocationType_1 = require("@/pages/common/states/MegaMenuLocationType");
var District_init_1 = require("@/pages/search/states/District.init");
var format_1 = require("@/utils/format");
var defaultBuildings = ['Cadogan', 'Cape Mansion', 'Casa Bella', 'Estroil Court', 'Fairlane Tower', 'Greenville House', 'Highcliff', 'May Tower 2', 'Pacific Palisades', 'Pacific View', 'Scenic Villas', 'Seymour', 'The Leighton Hill', 'The Masterpiece', 'The Merton', 'The Sail At Victoria', 'Tregunter Tower 3'];
var buildings = defaultBuildings.map(function (it, i) { return ({
    id: i,
    name: it,
    type: MegaMenuLocationType_1.MegaMenuLocationType.BUILDING,
    url: "/en/building/" + format_1.default.normalize(it) + "/" + i,
    image: 'https://images.okay.com/Property/Folder150/293415_635569341192383658.jpg'
}); });
exports.buildings = buildings;
var districts = District_init_1.defaultDistricts.filter(function (it) { return it.parent === 1000; }).slice(0, 20).map(function (it) { return ({
    id: it.id,
    name: it.name,
    url: "/en/district/" + format_1.default.normalize(it.name) + "/" + it.id,
    image: 'https://images.okay.com/Property/Folder150/293415_635569341192383658.jpg',
    type: MegaMenuLocationType_1.MegaMenuLocationType.DISTRICT
}); });
exports.districts = districts;
var popularDistricts = districts.slice(0, 3);
exports.popularDistricts = popularDistricts;
var popularBuildings = buildings.slice(0, 3);
exports.popularBuildings = popularBuildings;
